import React, { useState, useEffect } from 'react'
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Modal from 'react-bootstrap/Modal';
import auroraApi from "../../../../api/aurora-api";

/**
 * @callback onHideCallback
 * 
 * @param {boolean} show Determines if the modal is loaded and shown
 * @param {onHideCallback} onHide Callback to hide the modal when closed
 * @param {string} sfProjectId Sales Force ProjectId 
 * @param {string} currentDesignId Sales Force/Aurora design id 
 * @returns {React.JSX.Element}
 */

function AuroraDesignListModal({
  show,
  onHide,
  sfProjectId,
  currentDesignId,
  designs,
  syncDesign
}) {

  const [designList, setDesignList] = useState(designs);
  const [isSwitchLoading, setIsSwitchListLoading] = useState(false);
  const [currDesignId, setCurrDesignId] = useState(currentDesignId);
  
  useEffect(() => {
    setCurrDesignId(currentDesignId);
  }, [currentDesignId]);

  useEffect(() => {
    setDesignList(designs);
  }, [designs]);

  const changeDesign = async (designId) => {
    setIsSwitchListLoading(true);
    try {
      const res = await auroraApi.switchAuroraDesign({
        projectId: sfProjectId,
        auroraDesignId: designId
      });
      if (res.success) {
        setCurrDesignId(designId)
        const newList = [...designList];
        setDesignList(newList)
      }
      setIsSwitchListLoading(false)

    } catch (error) {
      console.error("Error in switching desing to aurora:", error);
    }
    console.log('todo: change design')
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered      
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Change Design</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ul className="list-group">
          {designList.map((design) => {
            return (
              <li className="list-group-item" key={design.id}>
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1">
                    <div className="d-flex">
                      <div className="flex-shrink-0 ms-2">
                        <h6 className="fs-14 mb-0">{design.name}</h6>
                        <small className="text-muted">System Size: {(design.system_size_stc / 1000)} kW</small>
                      </div>
                    </div>
                  </div>
                  <div className="flex-shrink-0">
                    {currDesignId && String(currDesignId) === String(design.id) ? (
                      <i className="fs-2 text-success bi bi-check-lg align-middle"></i>
                    ) : (
                      <Button variant="light"
                        disabled={isSwitchLoading}
                        onClick={!isSwitchLoading ? () => changeDesign(design.id) : null}
                        className="p-0">
                        { isSwitchLoading ? (
                          <Spinner animation="border" variant="dark" size="md"/>
                        ) : (
                          <i className="fs-2 bi bi-arrow-repeat align-middle"></i>
                        ) }                        
                      </Button>
                    )}
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
        <Button
          variant="primary"
          disabled={isSwitchLoading}
          onClick={!isSwitchLoading ? syncDesign : null}>
          Sync Design
        </Button>
      </Modal.Footer>
    </Modal>
  );
}


export default AuroraDesignListModal;